import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCard } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useDeleteCard({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: deleteCard,
    mutationKey: ['deleteCard'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getSavedCardsList']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
